import React from 'react';
import styled from 'styled-components';
import { trackNewsEvent } from '../utils/newsEvents';

const NewsItemContainer = styled.a`
  padding: 0.6rem 0.8rem;
  border-radius: 0;
  transition: all 0.25s ease;
  cursor: pointer;
  display: block;
  text-decoration: none;
  background-color: ${({ theme }) => theme.bgSecondary};
  color: ${({ theme }) => theme.text};
  margin-bottom: 0;
  box-shadow: none;
  border: none;
  position: relative;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  
  &:last-child {
    border-bottom: none;
  }
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 3px;
    background: ${({ theme }) => theme.accent};
    opacity: 0;
    transition: opacity 0.25s ease;
  }

  &:hover {
    background-color: ${({ theme }) => 
      theme === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)'};
  }
  
  &:hover::before {
    opacity: 1;
  }

  @media (max-width: 768px) {
    padding: 0.55rem 0.75rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0.7rem;
  }
`;

const NewsTitle = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.35rem;
  line-height: 1.3;
  letter-spacing: -0.01em;

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

const NewsMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.textSecondary};

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.2rem;
  }
`;

const NewsSource = styled.span`
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.65rem;
  letter-spacing: 0.03em;
  color: ${({ theme }) => theme.accent};
`;

const NewsTime = styled.span`
  opacity: 0.8;
  font-size: 0.65rem;
`;

const NewsItem = ({ news }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${day}.${month}.${year} ${hours}:${minutes}`;
  };

  const handleClick = (event) => {
    if (event.button !== 0) {
      return;
    }

    trackNewsEvent(news.guid, 'open');
  };

  const handleAuxClick = (event) => {
    if (event.button !== 1) {
      return;
    }

    trackNewsEvent(news.guid, 'open');
  };

  return (
    <NewsItemContainer
      href={news.link}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      onAuxClick={handleAuxClick}
    >
      <NewsTitle>{news.title}</NewsTitle>
      <NewsMeta>
        <NewsSource>{news.source}</NewsSource>
        <NewsTime>{formatDate(news.publish_time)}</NewsTime>
      </NewsMeta>
    </NewsItemContainer>
  );
};

export default NewsItem;
